exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Vsl7{position:relative;display:inline-block;cursor:pointer;font-weight:400;font-size:13px;color:#000;padding-left:20px;white-space:nowrap}._3Vsl7:hover{color:#ff5a5f}._3Vsl7 input{position:absolute;left:0;border:1px solid #aaa;border-radius:2px;cursor:pointer}._3Vsl7 input,._3Vsl7 input:checked{-webkit-appearance:none;width:15px;height:15px;outline:none}._3Vsl7 input:checked{border:1px solid #ffd906;background-color:#ffd906;border-radius:2px}._3Vsl7 input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:2;top:1px;left:-1px;overflow:hidden;width:17px;height:9px;margin-top:-6px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}", ""]);

// exports
exports.locals = {
	"checkbox": "_3Vsl7"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/UI/CheckBox/CheckBox.css
// module id = 1313
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46